module.exports = __webpack_public_path__ + "static/media/iconCantineMenu2.06edbcaf.svg";